import React from "react";
import styles from "features/payments/components/paymentusagedetaiheader.module.scss";
import { useTranslation } from "react-i18next";

const DepositUsageDetailHeader = () => {
  const t = useTranslation("deposits\\deposits").t;

  return (
    <div className="d-none d-sm-block mb-2 text-muted font-weight-bold">
      <div className="row no-gutters px-2 px-sm-3">
        <div className="col">
          <div className="row no-gutters">
            <div className="col-sm-7 col-lg-8">
              <div className="row no-gutters align-items-center">
                <div className="col-sm-7 col-lg-5">
                  {t("depositUsageHeader.used")}
                </div>
                <div className="col-sm-5 col-lg-7">
                  <div className="row no-gutters align-items-lg-center">
                    <div className="col-lg-6">
                      <span className="d-lg-none">{t("depositUsageHeader.numberDueDate")}</span>
                      <span className="d-none d-lg-inline">{t("depositUsageHeader.invoiceNumber")}</span>
                    </div>
                    <div className="d-none d-lg-block col-lg-6">
                      {t("depositUsageHeader.dueDate")}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-5 col-lg-4">
              <div className="row no-gutters">
                <div className="col-sm-6">
                  {t("depositUsageHeader.payment")}
                </div>
                <div className="col-sm-6 text-nowrap">
                  {t("depositUsageHeader.paymentDocument")}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`col-auto ${styles.btnCol}`} />
      </div>
    </div>
  );
};

export default DepositUsageDetailHeader;
